import { i18nKeys } from 'translationTypes'
import { AWS_BASE, COUNTRY_SHORTCODES } from '../../../../../constants'
import { SupportedCountryCode } from '../../../../../models/types'
import { AU_NCC_LINK_PAGE_CONFIG } from './australia'
import { NZ_NCC_LINK_PAGE_CONFIG } from './new-zealand'

export const NCC_LOGO_URL = `${AWS_BASE}/static/img/driver/ncc-logo.png`
export interface NccLinkPageConfig {
  docStringKeys: i18nKeys[]
  linkConfig: {
    startUrl: string
    hasEncodedClientRef?: boolean
  }
}

export const getNccLinkPageConfig = (
  countryCode: SupportedCountryCode
): NccLinkPageConfig => {
  switch (countryCode) {
    case COUNTRY_SHORTCODES.AU:
      return AU_NCC_LINK_PAGE_CONFIG
    case COUNTRY_SHORTCODES.NZ:
      return NZ_NCC_LINK_PAGE_CONFIG
    default:
      return {} as NccLinkPageConfig
  }
}
